import Row from './Row';
import RowWrapper from './RowWrapper';
import ColumnDetail from './ColumnDetail';
import { jsx as _jsx } from "react/jsx-runtime";
const ColumnDetails = _ref => {
  let {
    details = [],
    isOverWing
  } = _ref;
  return /*#__PURE__*/_jsx(Row, {
    isOverWing: Boolean(isOverWing),
    children: /*#__PURE__*/_jsx(RowWrapper, {
      children: details.map((_ref2, index) => {
        let {
          columnName = ''
        } = _ref2;
        return /*#__PURE__*/_jsx(ColumnDetail, {
          columnName: columnName
        }, `column_${index}`);
      })
    })
  });
};
export default ColumnDetails;
//# sourceMappingURL=ColumnDetails.js.map